import { render, staticRenderFns } from "./subfolder.vue?vue&type=template&id=35abbd5a&"
import script from "./subfolder.vue?vue&type=script&lang=js&"
export * from "./subfolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports